import * as React from 'react';
import { translate } from 'secullum-i18n';
import { Subscribe } from 'unstated';
import { FuncionarioContainer } from '../../../shared/containers/FuncionarioContainer';
import { retornarRotaWeb, Telas } from '../../../shared/modules/telas';
import CardFerias from '../../../shared/screens/ferias/CardFerias';
import LoggedInScreen from '../../components/LoggedInScreen';
import { RouteComponentComBancoIdProps, navegar } from '../../modules/routes';

interface Props extends RouteComponentComBancoIdProps {}

class Ferias extends React.Component<Props> {
  render() {
    return (
      <LoggedInScreen screenTitle={translate('Férias')}>
        <Subscribe to={[FuncionarioContainer]}>
          {() => (
            <CardFerias
              onSolicitarFerias={() =>
                navegar({
                  props: this.props,
                  path: retornarRotaWeb(Telas.SolicitarFerias)
                })
              }
              onVenderFerias={() =>
                navegar({
                  props: this.props,
                  path: retornarRotaWeb(Telas.VenderFerias)
                })
              }
              onAbrirSolicitacoes={() =>
                navegar({
                  props: this.props,
                  path: retornarRotaWeb(Telas.Solicitacoes)
                })
              }
            />
          )}
        </Subscribe>
      </LoggedInScreen>
    );
  }
}

export default Ferias;
